import { takeLatest, put, call } from 'redux-saga/effects';

import { filterPatrimonioManutencao } from '../service';
import { storage } from '@commons/storage';
import {
  NEW_FILTER_NEXT_PAGE_PATRIMONIO_MANUTENCAO,
  NEW_FILTER_NEXT_PAGE_PATRIMONIO_MANUTENCAO_PENDING,
  NEW_FILTER_NEXT_PAGE_PATRIMONIO_MANUTENCAO_SUCCESS,
  NEW_FILTER_NEXT_PAGE_PATRIMONIO_MANUTENCAO_FAILURE,
} from '../actionTypes';
import { CONFIG_SESSION } from '@handler/common/startSession';
import { formatDateDDMMYYYY } from '@components/common/format';
import { CONST_FILTER_PATRIMONIO_MANUTENCAO } from '@commons/consts';

function* sagaNewFilterNextPagePatrimonioManutencao(action) {
  yield put({ type: NEW_FILTER_NEXT_PAGE_PATRIMONIO_MANUTENCAO_PENDING })

  try {
    const idFazenda = JSON.parse(storage.get(CONFIG_SESSION)).fazendaSelecionada.id;

    let filterSaved = sessionStorage.getItem(CONST_FILTER_PATRIMONIO_MANUTENCAO) !== null ? JSON.parse(sessionStorage.getItem(CONST_FILTER_PATRIMONIO_MANUTENCAO)) : null;

    const datas = formatDateDDMMYYYY(filterSaved.dataInicial) + '_' + formatDateDDMMYYYY(filterSaved.dataFinal);

    let newFilter = {
      ...filterSaved,
      rows: action.rows,
      page: action.page,
    };

    const list = yield call(filterPatrimonioManutencao, idFazenda, datas, `&page=${newFilter.page}&size=${newFilter.rows}${newFilter.where}`);

    sessionStorage.setItem(CONST_FILTER_PATRIMONIO_MANUTENCAO, JSON.stringify(newFilter));

    yield put({
      type: NEW_FILTER_NEXT_PAGE_PATRIMONIO_MANUTENCAO_SUCCESS, list: list, filter: newFilter
    });
  } catch (error) {

    yield put({ type: NEW_FILTER_NEXT_PAGE_PATRIMONIO_MANUTENCAO_FAILURE })
    // console.error(error) // eslint-disable-line
  }
}

export default function* watchNewFilterNextPagePatrimonioManutencao() {
  yield takeLatest(NEW_FILTER_NEXT_PAGE_PATRIMONIO_MANUTENCAO, sagaNewFilterNextPagePatrimonioManutencao)
}